<script>
import { mapActions, mapMutations } from 'vuex';
/* import carousel from 'vue-owl-carousel' */
import request from '../services/request'

/* import Multiselect from 'vue-multiselect'

import StarRating from 'vue-star-rating' */

/* import galeryOffice from '@/components/GaleryOfficeComponent.vue' */

export default {
    components: {
        /* carousel,
        galeryOffice, */
    },
    data() {
        return {
            id:'',
            booking_id:'',
            booking: null,
            office: {},
            imagesFiles: [],
            error: {
                score: false
            },
            baseFiles: this.$BaseUrlFiles,
            send: false,
            sending: false,
        }
    },
    methods: {
        async get_office() {
            let service = request;
            // let _endpoint = `/booking/list/${this.id}`;
            let _endpoint = `/public/booking/${this.id}`;
            try {
                let { data } = await service.get(_endpoint)
                if (data) {
                    this.booking = data.data ? data.data : null;
                    this.booking_id = data.data ? data.data.id : null;
                    this.office = data.data ? data.data.room : null;
                    this.form.room_id = this.office ? this.office.id : null;
                    this.form.booking_id = data.data ? data.data.id : null;
                    if(!this.booking_id){
                        setTimeout(() => {
                            this.$router.push({ name: 'home' });
                        }, 3000);
                    }
                }
            } catch (error) {
                this.errors = await this.errorNotification(error)
            }
        },
        onChange() {
            this.$forceUpdate();
        },
        async download_report() {
            const vm = this;
            const host = window.location.host;
            let _base_url = '';
            console.log(host);
            console.log(vm.booking);
            if (host == 'centrosdeexperiencia.com') {
                _base_url = 'https://admin.centrosdeexperiencia.com/admin/download_assistant';
            }else{
                _base_url = 'http://sistema_reservas_admin.dv/admin/download_assistant';
            }
            if (vm.booking) {
                const _url_download = `${_base_url}?booking_id=${vm.booking.id}`;
                window.open(_url_download);
            }
        },
        ...mapMutations({
            setHeaderTitle: 'setHeaderTitle',
        }),
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            errorNotificationMessage: 'alert/errorMessage',
            successNotification: 'alert/success',
            authLoginWithTokenReport: "auth/authLoginWithTokenReport",
        }),
    },
    async mounted() {
        this.setHeaderTitle(`Control de asistencia`);
        this.id = this.$route.params.id;
        if (this.id) {
            await this.get_office();
        }
    },
    watch: {
        comment(newValue) {
            console.log(newValue);
            this.$forceUpdate();
        },
    },
}
</script>
<template>
    <div class="container p-4" v-if="booking">
        <div class="row">
            <div class="col-12">
                <div class="row mt-3">
                    <div class="col-12">
                        <h4 class="card-text mt-1 uppercase text-center">
                            Escanear el código QR para registrar tu asistencia
                        </h4>
                        <p class="card-text mt-1 uppercase text-center" style="font-size: 16px;">
                            <img :src="booking.qr_code" />
                        </p>
                    </div>
                    <div class="col-12 col-lg-6 mt-3">
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>RESERVACIÓN: </b>{{ booking.reservation_number }}
                        </p>
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>CURSO: </b>{{ booking.course ? booking.course.name : '' }} {{ booking.course_other ? ' - ' + booking.course_other : '' }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-6 mt-3">
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>CENTRO DE EXPERIENCIA: </b>{{ office.name }}
                        </p>
                        <p class="card-text mt-1 uppercase" style="font-size: 16px;">
                            <b>DIRECCIÓN DEL CENTRO EXPERIENCIA: </b>{{ office.address }}
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="6">
                                            <button class="btn btn-primary mr-1" @click="get_office()">
                                                <i class="fas fa-refresh"></i> Actualizar Lista
                                            </button>
                                            <button class="btn btn-danger" @click="download_report()">
                                                <i class="fas fa-download"></i> Descargar Reporte
                                            </button>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Apellidos</th>
                                        <th>NE</th>
                                        <th>División</th>
                                        <th>Territorio</th>
                                        <th>Región</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(assistant, index_assistant) in booking.assistants" :key="index_assistant">
                                        <td>{{ assistant.name }}</td>
                                        <td>{{ assistant.first_last_name }} {{ assistant.second_last_name }}</td>
                                        <td>{{ assistant.code_user }}</td>
                                        <td>{{ assistant.division }}</td>
                                        <td>{{ assistant.territory }}</td>
                                        <td>{{ assistant.region }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.btn-like {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 25px;
}

.div_star {
    position: absolute;
    right: 20px;
    font-size: 16px;
}

.rounded-r {
    border-radius: 20px;
    position: absolute;
    right: 10px;
    top: 25px;
    width: 150px;
}

.rounded-lg {
    border-radius: 20px !important;
}

.hr_head {
    margin: 0 auto;
    width: 96%;
    border-top: 2px solid #d4d6d5;
    top: 42px;
    position: relative;
}

.hr_footer {
    margin: 0 auto;
    width: 96%;
    border-top: 2px solid #d4d6d5;
    top: 282px;
    position: relative;
}

.shadow_cal {
    box-shadow: rgba(136, 165, 191, 0.48) 5px 6px 6px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.swal2-icon.swal2-success.swal2-icon-show {
    margin-top: 120px !important;
}

.img.swal2-image {
    position: absolute;
    left: 32% !important;
}

.brd-secondary {
    margin: 1px;
    border: 2px solid #ddd;
    padding: 15px 10px 10px 10px;
    border-radius: 5px;
}

input[type='radio'] {
    accent-color: #da271b;
}

.image-upload>input {
    display: none;
}

@media (max-width: 575px) {
    .rounded {
        height: auto;
    }
}

.rounded {
    height: 150px;
    text-transform: capitalize;
}

.shadow {
    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>
